import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MemoriesService } from '../service/memories.service';
import { SidebarService } from 'src/app/core/services/sidebar.service';
@Component({
  selector: 'app-memories',
  templateUrl: './memories.component.html',
  styleUrls: ['./memories.component.css']
})
export class MemoriesComponent implements OnInit {
  memoriesdata:any;
  sidebarCollapsed: boolean = false;
  imagepath:any='../../../assets/images/party.jfif'
  memories_data=[
    {
      title:'Offsites',
      routename:'offsite',
      thumbnail_image:this.imagepath
    },
    { 
      title:'Townhalls',
      routename:'townhall',
      thumbnail_image:this.imagepath
    },
    {
      title:'Awards & Conferences',
      routename:'anc',
      thumbnail_image:this.imagepath
    },
    {
      title:'Life at Amplus',
      routename:'life_at_amplus',
      thumbnail_image:this.imagepath
    }
    
  ]
  constructor(private router: Router,private memories:MemoriesService, private sidebarService: SidebarService) { }

  ngOnInit(): void {
    // Subscribe to sidebar collapsed state
    this.sidebarService.collapsed$.subscribe(collapsed => {
      this.sidebarCollapsed = collapsed;
    });

      this._getMemoriesCategories();
  }
    

  _getMemoriesCategories(){
    this.memoriesdata=this.memories_data;
  }

  navigateToSubroute(category:string) {
    this.router.navigate(['/memories', category]);
}
 
}
